/** Preserve the report's business context when the chart leaves the application. */
export async function chartPngWithContext(url: string, context: string): Promise<string> {
  const image = new Image()
  await new Promise<void>((resolve, reject) => {
    image.onload = () => resolve()
    image.onerror = () => reject(new Error('Не удалось подготовить изображение графика'))
    image.src = url
  })
  const canvas = document.createElement('canvas')
  const painter = canvas.getContext('2d')
  if (!painter) throw new Error('Браузер не поддерживает экспорт изображения')
  canvas.width = Math.max(image.width, 640)
  painter.font = '24px sans-serif'
  const lines: string[] = []
  let line = ''
  const words = context.split(/\s+/).flatMap((word) => {
    const chunks: string[] = []
    let chunk = ''
    for (const char of word) {
      if (chunk && painter.measureText(chunk + char).width > canvas.width - 48) {
        chunks.push(chunk)
        chunk = char
      } else chunk += char
    }
    if (chunk) chunks.push(chunk)
    return chunks
  })
  for (const word of words) {
    const next = line ? `${line} ${word}` : word
    if (line && painter.measureText(next).width > canvas.width - 48) {
      lines.push(line)
      line = word
    } else line = next
  }
  if (line) lines.push(line)
  const headerHeight = lines.length * 34 + 48
  canvas.height = image.height + headerHeight
  painter.fillStyle = '#fff'
  painter.fillRect(0, 0, canvas.width, canvas.height)
  painter.font = '24px sans-serif'
  painter.fillStyle = '#111827'
  lines.forEach((text, index) => painter.fillText(text, 24, 34 + index * 34))
  painter.drawImage(image, 0, headerHeight)
  return canvas.toDataURL('image/png')
}
